import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import UnitPicker, { renderUnit } from '../UnitPicker/UnitPicker';
import * as Styled from '../../Sizes.styles';
export default (function () {
  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      activeUnit = _useState2[0],
      changeUnit = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnitPicker, {
    activeUnit: activeUnit,
    changeUnit: changeUnit
  }), /*#__PURE__*/React.createElement(Styled.ResponsiveWrapper, null, /*#__PURE__*/React.createElement(Styled.Table, null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\xA0"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "EU"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Chest"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Waist"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Seat"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Collar")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "34"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "44"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([87, 34], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([74, 28], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([89, 35], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([35.5, 14], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "36"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "46"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([92, 36], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([79, 30], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([94, 37], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([37, 14.5], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "38"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "48"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([97, 38], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([84, 32], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([99, 39], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([38, 15], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "40"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "50"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([102, 40], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([89, 34], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([104, 41], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([39.5, 15.5], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "42"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "52"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([107, 42], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([94, 36], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([109, 43], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([40.5, 16], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "44"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "54"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([112, 44], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([99, 38], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([114, 45], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([42, 16.5], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "46"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "56"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([117, 46], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([105, 40], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([119, 47], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([43, 17], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "48"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "58"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([122, 48], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([111, 42], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([124, 49], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([44.5, 17.5], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "50"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "60"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([127, 50], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([117, 44], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([129, 51], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([45.5, 18], activeUnit)))))));
});